import {
  SimilarityAnalysisResult,
  SimilarityFaultFrequencyItem,
} from '@/interfaces/types/AnalysisResult';

/**
 * 파일별 문제 데이터 검출 빈도 계산
 * Database에 저장해두기엔 너무 오브젝트 크기가 커질 수 있으므로, On demand 생성
 * TBD 파일별 count 뿐 만 아니라 각 경고 대상과 유사도도 함께 저장 및 그를 나타낼 수 있는 UI
 */
export function countFileFrequency(
  similarityAnalysisResult: SimilarityAnalysisResult,
): SimilarityAnalysisResult {
  const countedAnalysisResult: SimilarityAnalysisResult = JSON.parse(
    JSON.stringify(similarityAnalysisResult),
  );

  countedAnalysisResult.analysis_list.forEach((folder) => {
    const frequencyDict: Record<
      string,
      { error_count: number; warning_count: number }
    > = {};

    // error case count
    folder.error_list.forEach((errorCase) => {
      [errorCase.image1, errorCase.image2].forEach((image) => {
        if (image in frequencyDict) {
          frequencyDict[image].error_count += 1;
        } else {
          frequencyDict[image] = {
            error_count: 1,
            warning_count: 0,
          };
        }
      });
    });

    // // warning case count // Don't count
    // folder.warning_list.forEach((warningCase) => {
    //   [warningCase.image1, warningCase.image2].forEach((image) => {
    //     if (image in frequencyDict) {
    //       frequencyDict[image].warning_count += 1;
    //     } else {
    //       frequencyDict[image] = {
    //         error_count: 0,
    //         warning_count: 1,
    //       };
    //     }
    //   });
    // });

    // Dictionary => List
    const frequencyList: SimilarityFaultFrequencyItem[] = [];
    for (const file in frequencyDict) {
      frequencyList.push({
        file: file,
        error_count: frequencyDict[file].error_count,
        warning_count: frequencyDict[file].warning_count,
      });
    }

    // sort by filename
    folder.frequency_list = frequencyList.sort((a, b) => {
      return a.file.localeCompare(b.file);
    });
  });

  return countedAnalysisResult;
}
